import ClientService from './service';

export * from './reqres';

export default ClientService;
